import { create } from "zustand";
import { Point } from "../RampCanvasV2/RampCanvasV2";
import { BoundingBox, HandleType } from "./types";

interface TransformState {
  /** Currently active handle being dragged */
  activeHandle: HandleType | null;
  /** Handle currently being hovered */
  hoveredHandle: HandleType | null;
  /** Mouse position when transform started */
  startMousePos: Point | null;
  /** Bounding box when transform started */
  startBounds: BoundingBox | null;
  /** Original points for each shape when transform started */
  startShapePoints: Map<string, Point[]>;
  /** Starting angle for rotation (null = not yet set) */
  startRotationAngle: number | null;

  // Actions
  startTransform: (
    handle: HandleType,
    mousePos: Point,
    bounds: BoundingBox,
    shapePoints: Map<string, Point[]>
  ) => void;
  endTransform: () => void;
  setHoveredHandle: (handle: HandleType | null) => void;
  setStartRotationAngle: (angle: number | null) => void;
}

export const useTransformState = create<TransformState>((set) => ({
  activeHandle: null,
  hoveredHandle: null,
  startMousePos: null,
  startBounds: null,
  startShapePoints: new Map(),
  startRotationAngle: null,

  startTransform: (handle, mousePos, bounds, shapePoints) =>
    set({
      activeHandle: handle,
      startMousePos: mousePos,
      startBounds: bounds,
      startShapePoints: shapePoints,
    }),

  endTransform: () =>
    set({
      activeHandle: null,
      startMousePos: null,
      startBounds: null,
      startShapePoints: new Map(),
      startRotationAngle: null,
    }),

  setHoveredHandle: (handle) => set({ hoveredHandle: handle }),

  setStartRotationAngle: (angle) => set({ startRotationAngle: angle }),
}));
